'use client'

import dynamic from 'next/dynamic'

export const ClientDrwer = dynamic(() => import('./Drawer').then(({ DrawerIOS }) => DrawerIOS), {
	ssr: false
})
